import React from 'react';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';

const Title = props => {
  return (
    <Grid className={clsx(props.classes.titleRoot, props.styles)}>
      <h1 className={props.classes.headerTitle}>{props.name && props.name}</h1>
    </Grid>
  );
};

export default withStyles(useStyles)(Title);
